import { NgModule, LOCALE_ID, ErrorHandler } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { PublicComponent } from './Pages/public/public.component';
import { APP_BASE_HREF, CommonModule } from '@angular/common';
import { CoreModule } from './Pages/secure/secure-core.module';
import { PublicModule } from './Pages/public/public.module';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LoggedInGuard } from './Helpers/Guards/loggedin.guard';
import { FooterComponent } from './Components/footer/footer.component';
import { ToastrModule, ToastContainerModule } from 'ngx-toastr'
import { MessageService } from 'primeng/components/common/messageservice';
import { BlockUIModule } from 'ng-block-ui';
import { PaginaNaoEncontradaComponent } from './Components/pagina-nao-encontrada/pagina-nao-encontrada.component';
import { AuthInterceptor } from './Helpers/auth.interceptor';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ToastModule } from 'primeng/toast'
import { ApplicationErrorHandler } from './Helpers/application.error.handler';

@NgModule({
  declarations: [
    AppComponent,
    PublicComponent,
    FooterComponent,
    PaginaNaoEncontradaComponent
  ],
  imports: [
    CommonModule,
    BrowserModule,
    BrowserAnimationsModule,
    CoreModule,
    PublicModule,
    AppRoutingModule,
    ToastModule,
    ToastrModule.forRoot({
      closeButton: true,
      preventDuplicates: true,
      enableHtml: true,
      timeOut: 5000,
      progressBar: true,
      positionClass: 'toast-center-center'
    }),
    ToastContainerModule,
    BlockUIModule.forRoot()
  ],
  exports: [
    ToastModule,
    ToastrModule,
    ToastContainerModule,
    BrowserAnimationsModule
  ],
  providers: [LoggedInGuard, MessageService,
    { provide: APP_BASE_HREF, useValue: '/' },
    { provide: LOCALE_ID, useValue: 'pt' },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: ErrorHandler, useClass: ApplicationErrorHandler }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
